import { render } from "./edit-options.vue?vue&type=template&id=9c798f4c&ts=true"
import script from "./edit-options.vue?vue&type=script&lang=ts"
export * from "./edit-options.vue?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__